const { REACT_APP_LXC_AIRTABLE_API_KEY } = process.env;

export const GLOSSARY_API_DETAILS = {
  URL: "https://api.airtable.com/v0/appJSNxwpka6HJxbE/Glossary%20Data",
  KEY: REACT_APP_LXC_AIRTABLE_API_KEY,
};
